// use en-GB as default for English language otherwise formatter pick US defaults.
const language = window.navigator.language === 'en' ? 'en-GB' : window.navigator.language;

export const numberFormat = new Intl.NumberFormat(language, { minimumFractionDigits: 2 });

const dateTimeOptions = { year : 'numeric', month: '2-digit', day: '2-digit'};
export const dateTimeFormat = new Intl.DateTimeFormat(language, dateTimeOptions);